import { render } from "./ModelSelect.vue?vue&type=template&id=1f8d4972"
import script from "./ModelSelect.vue?vue&type=script&lang=js"
export * from "./ModelSelect.vue?vue&type=script&lang=js"
script.render = render

export default script